import type { BlogPostSummaryRequest } from './types';

export const BLOG_QUERY_KEYS = {
  default: () => ['blog'] as const,
  getBlogPostsSummary: (params?: BlogPostSummaryRequest) => [...BLOG_QUERY_KEYS.default(), 'summary', params] as const,
};
